import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import useAuth from "../../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import useLocalStorage, {
  PASSWORD_EXPIRY_SHOWN_KEY,
} from "../../hooks/useLocalStorage";

const PasswordExpiryWatcher = () => {
  const auth: any = useAuth();
  const [open, setOpen] = useState(false);
  let navigate = useNavigate();

  const { data: passwordExpiryShown, storeData } = useLocalStorage(
    PASSWORD_EXPIRY_SHOWN_KEY,
    false,
  );

  useEffect(() => {
    if (
      auth?.user?.notify_password_expiry === true &&
      passwordExpiryShown !== true
    ) {
      setOpen(true);
      storeData(true);
    }
  }, [auth?.user]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangePassword = () => {
    setOpen(false);
    // redirect user to change password page
    navigate("/account/profile");
  };
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          gap={1}
        >
          <WarningAmberRoundedIcon color="warning" sx={{ fontSize: 48 }} />
          <Typography variant="h6" fontWeight={600}>
            Password Expiry Notice
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography textAlign="center">
          Your password is about to expire. Please change it to continue using
          your account securely.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Later
        </Button>
        <Button onClick={handleChangePassword} variant="contained">
          Change Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordExpiryWatcher;
